interface LeadData {
  name: string;
  email: string;
  phone?: string;
  message?: string;
  serviceInterest?: string;
  province?: string;
  city?: string;
  address?: string;
  siteName: string;
  pageName: string;
  pageUrl: string;
  userAgent?: string;
  ipAddress?: string;
  utmParams?: Record<string, string>;
}

export const sendLeadToResend = async (leadData: LeadData) => {
  try {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

    const apiUrl = `${supabaseUrl}/functions/v1/send-lead-email`;

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${supabaseAnonKey}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(leadData)
    });

    if (!response.ok) {
      const error = await response.text();
      throw new Error(`Failed to send email: ${error}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending lead email:', error);
    throw error;
  }
};

export const getUTMParams = (): Record<string, string> => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams: Record<string, string> = {};
  
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
    const value = urlParams.get(param);
    if (value) {
      utmParams[param] = value;
    }
  });
  
  return utmParams;
};